import React, {useState} from 'react'
import { useNavigate } from 'react-router'
import { addIcon } from '@/assets/img/imgAssets'
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import PulseLoader from "react-spinners/PulseLoader"
import { useGetCapabilitiesServiceFunctionAreaTypesQuery } from './capabilitiesServiceFunctionAreaTypesApiSlice'

const EtCapabilitiesServiceFunctionAreaTypeList = ({ setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }) => {

  // First Created - 17 Nov 2024
  // Author - Atul Pandey
  // Inherited from functionType
  // Updated - 28 Feb 2025 - updated the serviceFunctionArea with props - { setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }
  // Updated - 28 Feb 2025 - switched from navigate to onAdd, onUpdate, onDelete, setSelectedEntityId
    
  // 1 - Set navigation
  const navigate = useNavigate()
  
  // 2a - Initialize showDetails state as an object where key is the capabilitiesServiceFunctionAreaType index
  const [showDetails, setShowDetails] = useState({}); // Toggle service type sections
  const [showServiceTypeSection, setShowServiceTypeSection] = useState({}); // Toggle service type sections

  const { data: capabilitiesServiceFunctionAreaTypesData, isError, error, isLoading } =
  useGetCapabilitiesServiceFunctionAreaTypesQuery();


// 2b - Group service function areas by service type
const groupedServiceFunctionAreas = capabilitiesServiceFunctionAreaTypesData?.ids?.reduce((acc, id) => {
  const capability = capabilitiesServiceFunctionAreaTypesData.entities[id];
  const serviceType = capability.capabilitiesServiceType?.capabilitiesServiceTypeName;
  const serviceTypePic = capability.capabilitiesServiceType?.pic;

  if (!acc[serviceType]) {
    acc[serviceType] = { serviceTypePic, serviceFunctionAreas: [] };
  }
  acc[serviceType].serviceFunctionAreas.push(capability);
  return acc;
}, {});


  
  // 3a - Toggle the show/hide state for the specific capabilitiesServiceFunctionAreaType index
  const handleToggle = (index) => {
        setShowDetails(prev => prev === index ? null : index);
  }

  // 3b - Toggle Show serviceFunctionArea for show creation notes -- 07 Oct 2024
//   const handleToggleDomainTypeNameSection = (sectionId) => {
//     setShowDomainTypeNameSection((prev) => ({
//       ...prev,
//       [sectionId]: !prev[sectionId],
//     }))
// }
    
  // 4 - Create an object for setting inner HTML
    const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
     }
  

  // 5 -  Optional: handle loading and error states
    if (isLoading) return <PulseLoader color={"#ea580c"} />
    if (isError) return <div>Error occurred: {error?.data?.message}</div>


  return (
    <div className='bg-gray-200 m-1 p-1 rounded mx-auto'>
        {/* Header */}
        <div className='flex justify-start items-center m-1 p-1'>

            <div><p className='font-poppins text-2xl m-1 p-1 font-bold'>Et Capabilities ServiceFunctionArea Types</p></div>
            <div>
          <img
            src={addIcon}
            alt=""
            className="h-10 w-10 cursor-pointer"
            // onClick={() => navigate("/capabilitiesServiceFunctionAreatypes/create")}
            onClick={onAdd} // 28 Feb 2025
          />
        </div>

        </div>

        {/* CapabilitiesServiceFunctionAreaType Data */}
        <div id='capabilitiesServiceFunctionAreaType-data' className='bg-white rounded m-1 p-1 font-poppins'>
            {capabilitiesServiceFunctionAreaTypesData?.ids.length === 0 && (
                <div><p>No capabilities ServiceFunctionArea type data exists. Click above to create one</p></div>
            )}

            <div className='bg-gray-50 rounded'>
              {Object.entries(groupedServiceFunctionAreas)?.map(([serviceTypeName, { serviceTypePic, serviceFunctionAreas }], index) => (
                <div key={serviceTypeName + index} className='bg-gray-100 rounded m-1 p-1 border'>
                  {/* Service Type Header */}
                  <div className='flex justify-start items-center m-1 p-1'>
                    <div onClick={() => setShowServiceTypeSection((prev) => ({
                      ...prev,
                      [serviceTypeName]: !prev[serviceTypeName],
                    }))}
                      className="mx-2 cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30 hover:bg-white">
                      {showServiceTypeSection[serviceTypeName] ? <MinusIcon className="h-3 w-3 text-orange-600 " /> : <PlusIcon className="h-3 w-3 text-orange-600 " />}
                    </div>
                    <div>
                      <p className='text-sm font-bold mx-1 px-1'>{index + 1} - </p>
                    </div>
                    {serviceTypePic && (
                      <div className='flex justify-center items-center h-7 w-7 bg-gray-100 hover:bg-white rounded-full cursor-pointer mr-2'>
                        <img src={serviceTypePic} alt="" className='h-5 w-5' />
                      </div>
                    )}
                    <p className='text-sm font-bold mx-2'>{serviceTypeName}</p>
                  </div>

                  {/* Render Service Function Areas */}
                  {showServiceTypeSection[serviceTypeName] && (
                    <div>
                      {serviceFunctionAreas.map((serviceFunction, idx) => (
                        <div key={serviceFunction._id} className='bg-gray-200 rounded m-1 p-1 border'>
                          <div className='flex justify-between items-center m-1 p-1'>
                            <div className='flex justify-start items-center mx-2'>
                              <div onClick={() => setShowDetails((prev) => ({ ...prev, [serviceFunction._id]: !prev[serviceFunction._id] }))}>
                                {showDetails[serviceFunction._id] ? (
                                  <MinusIcon className="h-3 w-3 text-orange-600 " />
                                ) : (
                                  <PlusIcon className="h-3 w-3 text-orange-600 " />
                                )}
                              </div>

                              <p className='text-xs font-bold mx-1 px-1'>{idx + 1} - {serviceFunction.capabilitiesServiceFunctionAreaTypeName}</p>
                            </div>
                            <div className='flex justify-start items-center'>
                              <div 
                              
                              // onClick={() => navigate(`/capabilitiesServiceFunctionAreaTypes/update/${serviceFunction._id}`)} 
                              onClick={() => onUpdate(serviceFunction._id)} // 28 Feb 2025
                              
                              
                              className='cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30 hover:bg-white'>
                                <PencilSquareIcon className="h-3 w-3 text-orange-600 " />
                              </div>
                              <div 
                              
                              // onClick={() => navigate(`/capabilitiesServiceFunctionAreaTypes/delete/${serviceFunction._id}`)} 
                              onClick={() => onDelete(serviceFunction._id)} // 28 Feb 2025
                              
                              
                              className='cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30 hover:bg-white'>
                                <TrashIcon className="h-3 w-3 text-orange-600 " />
                              </div>
                            </div>
                          </div>

                          {/* Service Function Details */}
                          {showDetails[serviceFunction._id] && (
                            <div className='bg-white rounded text-xs py-1'>
                              <p className='font-bold m-1 p-1 border-b-2 border-orange-600'>Description:</p>
                              <div dangerouslySetInnerHTML={createMarkup(serviceFunction.capabilitiesServiceFunctionAreaTypeDesc)} className='m-1 p-1'></div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>


        </div>

    </div>
  )
}

export default EtCapabilitiesServiceFunctionAreaTypeList